import * as React from "react";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import Settings from "@mui/icons-material/Settings";
import Logout from "@mui/icons-material/Logout";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import useAuth from "../../hooks/useAuth";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import defaultProfileImage from "../../assests/images/dummy-user-profile.png";
import { styled } from "@mui/material/styles";

const StyledMenu = styled(Menu)(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: '8px',
    minWidth: '200px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
    border: '1px solid #e5e7eb',
    '& .MuiMenuItem-root': {
      padding: theme.spacing(1.5, 2),
      '&:hover': {
        backgroundColor: theme.palette.action.hover,
      },
    },
    '& .MuiDivider-root': {
      margin: theme.spacing(0.5, 0),
    },
    '&::before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      top: 0,
      right: 14,
      width: 10,
      height: 10,
      backgroundColor: '#ffffff',
      borderTop: '1px solid #e5e7eb',
      borderLeft: '1px solid #e5e7eb',
      transform: 'translateY(-50%) rotate(45deg)',
      zIndex: 0,
    },
  },
}));

const UserNameText = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  color: theme.palette.text.primary,
  marginLeft: theme.spacing(1),
}));

export default function AccountMenu({ logout }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const { tokenCookies } = useAuth();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.authen);
  const avatar = user?.avatar || defaultProfileImage;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <React.Fragment>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Tooltip title="Account settings">
          <IconButton 
            onClick={handleClick} 
            sx={{ 
              display: "flex", 
              alignItems: "center",
              '&:hover': {
                backgroundColor: 'action.hover',
              }
            }}
          >
            <Avatar 
              src={avatar} 
              sx={{ 
                width: 36, 
                height: 36, 
                mr: 1,
                border: '1px solid',
                borderColor: 'divider'
              }}
            />
            <UserNameText variant="body1" sx={{ display: { xs: "none", md: "block" } }}>
              {user?.name || "User"}
            </UserNameText>
            <ArrowDropDownIcon sx={{ color: 'text.secondary' }} />
          </IconButton>
        </Tooltip>
      </Box>

      <StyledMenu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem 
          onClick={() => {
            handleClose();
            navigate('/settings');
          }}
        >
          <ListItemIcon>
            <Avatar src={avatar} sx={{ width: 24, height: 24 }} />
          </ListItemIcon>
          <Typography variant="body2">Profile</Typography>
        </MenuItem>
        
        <Divider />

        <MenuItem 
          onClick={() => {
            handleClose();
            navigate('/settings/accounts');
          }}
        >
          <ListItemIcon>
            <Settings fontSize="small" sx={{ color: 'text.secondary' }} />
          </ListItemIcon>
          <Typography variant="body2">Accounts</Typography>
        </MenuItem>
        
        <MenuItem onClick={logout}>
          <ListItemIcon>
            <Logout fontSize="small" sx={{ color: 'text.secondary' }} />
          </ListItemIcon>
          <Typography variant="body2">Logout</Typography>
        </MenuItem>
      </StyledMenu>
    </React.Fragment>
  );
}